<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-一日三检记录-添加
    -->
  <el-dialog
    title="添加一日三检记录"
    :visible.sync="dialogVisible"
    @close="handleDialogClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
        <div class="common-form">添加一日三检记录</div>
        
        <el-form-item label="车牌号" prop="car_number">
          <el-input v-model="form.car_number" placeholder="请输入车牌号" class="max-w460"></el-input>
        </el-form-item>
        
        <el-form-item label="所属组织" prop="ma_company_id">
          <el-select 
            v-model="form.ma_company_id" 
            placeholder="请选择所属组织"
            style="width: 100%;"
            clearable
            filterable
            :loading="orgLoading"
          >
            <el-option label="请选择所属组织" value=""></el-option>
            <el-option
              v-for="dept in organizationList"
              :key="dept.ma_company_id"
              :label="dept.name"
              :value="dept.ma_company_id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="检查时间" prop="inspect_time">
          <div class="block">
            <el-date-picker
              size="small"
              v-model="form.inspect_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
        </el-form-item>
        
        <el-form-item label="检查人" prop="inspect_uid">
          <el-select
            v-model="form.inspect_uid"
            multiple
            placeholder="请选检查人"
            clearable
          >
            <el-option
              v-for="item in peopleList"
              :key="item.ma_yg_id"
              :label="`${item.name}(${item.organization_name || '无组织'})`"
              :value="item.ma_yg_id"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="签名" prop="sign_img">
          <div class="d-s-c" style="flex-wrap: wrap;">
            <div v-if="form.sign_img" class="img-box">
              <img v-if="form.sign_img" :src="form.sign_img" class="product-img" width="100" height="100" />
              <div class="img-delete">
                <el-button type="text" size="small" @click="deleteSignImg">删除</el-button>
              </div>
            </div>
            <div v-if="!form.sign_img" class="d-c-c d-c p-0-10-0 upload-btn" @click="openSignUpload">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <p>上传签名</p>
            </div>
          </div>
        </el-form-item>
        
        <el-form-item label="检查结果" prop="inspect_res">
          <el-select size="small" v-model="form.inspect_res">
            <el-option label="请选择" value=""></el-option>
            <el-option label="合格" value="1"></el-option>
            <el-option label="不合格" value="2"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="状态" prop="status">
          <el-select size="small" v-model="form.status">
            <el-option label="请选择" value=""></el-option>
            <el-option label="待排查" value="0"></el-option>
            <el-option label="整改中" value="1"></el-option>
            <el-option label="已完成" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核确认人" prop="review_uid">
          <el-select 
            v-model="form.review_uid" 
            placeholder="请选择审核确认人"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="item in peopleList"
              :key="item.ma_yg_id"
              :label="item.name"
              :value="item.ma_yg_id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="审核确认时间" prop="review_time">
          <div class="block">
            <el-date-picker
              size="small"
              v-model="form.review_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
        </el-form-item>
        
        <el-form-item label="整改确认人" prop="rectificat_uid">
          <el-select 
            v-model="form.rectificat_uid" 
            placeholder="请选择整改确认人"
            style="width: 100%;"
            clearable
            filterable
          >
            <!-- 修复：整改确认人应该用人员列表而不是组织列表 -->
            <el-option
              v-for="person in peopleList"
              :key="person.ma_yg_id"
              :label="person.name"
              :value="person.ma_yg_id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="整改确定时间" prop="rectificat_time">
          <div class="block">
            <el-date-picker
              size="small"
              v-model="form.rectificat_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
        </el-form-item>
        
        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>
        
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      
      <!--业务附件上传组件-->
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
        上传图片
      </Upload>
      
      <!--签名图片组件-->
      <Upload v-if="isSignUpload" :config="{ total: 1 }" :isupload="isSignUpload" @returnImgs="returnSignImgsFunc">
        上传签名
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import Inspection_threeApi from '@/api/inspection_three.js';
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    Categoryas,
    draggable,
    Uediter
  },
  props: ["open_add"],
  data() {
    return {
      peopleList: [],
      organizationList: [],
      orgLoading: false,
      isupload: false,
      isImg: false,
      isSignUpload: false,
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      form: {
        ma_company_id: '',
        car_number: '',
        inspect_time: '',
        inspect_uid: [], 
        sign_img: '',
        inspect_res: '',
        status: '',
        review_uid: '',
        review_time: '',
        rectificat_uid: '',
        rectificat_time: '',
        sort: '',
        image: [],
        bannar: []
      },
      loading: false,
      rules: {
        car_number: [{ required: true, message: '请输入车牌号', trigger: 'blur' }], 
        ma_company_id: [{ required: true, message: '请选择所属组织', trigger: 'change' }],
        inspect_time: [{ required: true, message: '请选择检查时间', trigger: 'change' }],
        inspect_uid: [{ 
          required: true, 
          message: '请选择检查人', 
          trigger: 'change',
          type: 'array' 
        }],
        sign_img: [{ required: true, message: '请输入签名', trigger: 'blur' }],
        inspect_res: [{ required: true, message: '请选择检查结果', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        review_uid: [{ required: true, message: '请选择审核确认人', trigger: 'change' }],
        review_time: [{ required: true, message: '请选择审核确认时间', trigger: 'change' }],
        rectificat_uid: [{ required: true, message: '请选择整改确认人', trigger: 'change' }],
        rectificat_time: [{ 
          required: true, 
          message: '请选择整改确认时间', 
          trigger: 'change' 
        }], 
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }] 
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.loadOrganization();
    this.loadPeopleList();
    this.dialogVisible = this.open_add;
  },
  methods: {
    // 加载人员列表 - 修复空值判断
    async loadPeopleList() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_yg',
          action: 'getList',
        });
        if (!response) {
          this.peopleList = [];
          return;
        }
        
        if (response.code === 1 && response.data && response.data.list) { 
          this.peopleList = response.data.list.data || [];
        } else {
          this.peopleList = [];
        }
      } catch (error) {
        this.peopleList = []; // 确保数组有初始值
      }
    },
    
    // 加载组织列表 - 修复空值判断
    async loadOrganization() {
      this.orgLoading = true;
      try {
        const response = await AfuncApi.call({
          model: 'ma_company',
          action: 'getList',
          page: 1,
          list_rows: 1000
        });
        
        if (response.code === 1 && response.data && response.data.list) {
          this.organizationList = response.data.list.data || [];
        } else {
          this.$message.warning('获取组织列表失败：' + (response.msg || '未知错误'));
          this.organizationList = [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.$message.error('加载组织列表失败，请稍后重试');
        this.organizationList = []; // 确保数组有初始值
      } finally {
        this.orgLoading = false;
      }
    },
    
    chooseCategory() {
      this.iscategorya = true;
    },
    
    openUpload(e) {
      this.isupload = true;
    },
    
    // 处理弹窗关闭
    handleDialogClose() {
      this.$emit("close", { openDialog: false, "type": "" });
      // 重置表单
      this.$refs.form.resetFields();
      this.form = {
        code: '',
        ma_organization_id: '',
        car_number: '',
        inspect_time: '',
        inspect_uid: [],
        sign_img: '',
        inspect_res: '',
        status: '',
        review_uid: '',
        review_time: '',
        rectificat_uid: '',
        rectificat_time: '',
        sort: '',
        image: [],
        bannar: []
      };
    },
    
    // 取消操作
    cancelFunc() {
      this.handleDialogClose();
    },
    
    // 表单提交
    async onSubmit() {
      try {
        const valid = await this.$refs.form.validate();
        if (!valid) return;
        
        this.loading = true;
        const data = await Inspection_threeApi.add(this.form, true);
        
        this.$message({
          message: data.msg || '添加成功',
          type: 'success'
        });
        
        this.handleDialogClose();
      } catch (error) {
        console.error('提交失败:', error);
        this.$message.error('添加失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    
    // 打开图片上传
    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },
    
    // 打开签名上传
    openSignUpload() {
      this.isSignUpload = true;
    },
    
    // 删除签名
    deleteSignImg() {
      this.form.sign_img = '';
    },
    
    // 处理上传图片返回
    returnProductImgsFunc(e) {
      if (!e || e.length === 0) {
        this.isProductUpload = false;
        return;
      }
      
      // 验证图片格式 - 优化逻辑
      const imgExts = ["bmp", "jpg", "jpeg", "png", "gif"];
      const isValid = e.every(element => {
        const ext = element.file_path.split(".").pop().toLowerCase();
        return imgExts.includes(ext);
      });
      
      if (!isValid) {
        this.$message.error("图片类型有误，请选择 bmp、jpg、jpeg、png、gif 格式的图片");
        this.isProductUpload = false;
        return;
      }
      
      // 更新图片数组
      if (this.code === 'album') {
        this.form.image = [...this.form.image, ...e];
      } else if (this.code === 'bannar') {
        this.form.bannar = [...this.form.bannar, ...e];
      }
      
      this.isProductUpload = false;
    },
    
    // 处理签名上传返回
    returnSignImgsFunc(e) {
      if (!e || e.length === 0) {
        this.isSignUpload = false;
        return;
      }
      
      // 验证图片格式
      const imgExts = ["bmp", "jpg", "jpeg", "png", "gif"];
      const isValid = e.every(element => {
        const ext = element.file_path.split(".").pop().toLowerCase();
        return imgExts.includes(ext);
      });
      
      if (!isValid) {
        this.$message.error("图片类型有误，请选择 bmp、jpg、jpeg、png、gif 格式的图片");
        this.isSignUpload = false;
        return;
      }
      
      // 设置签名图片（只取第一张）
      this.form.sign_img = e[0].file_path;
      this.isSignUpload = false;
    },
    
    // 删除图片
    deleteImg(index, code) {
      if (code === 'album' && this.form.image[index]) {
        this.form.image.splice(index, 1);
      } else if (code === 'bannar' && this.form.bannar[index]) {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.img-box {
  position: relative;
  display: inline-block;
  margin-right: 10px;
}

.img-box img {
  border: 1px solid #ddd;
  border-radius: 4px;
}

.img-delete {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 2px 8px;
  border-radius: 0 4px 0 4px;
  cursor: pointer;
}

.upload-btn {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8c939d;
  background: #fafafa;
}

.upload-btn:hover {
  border-color: #409eff;
  color: #409eff;
}

.upload-btn i {
  font-size: 28px;
  margin-bottom: 8px;
}

.upload-btn p {
  margin: 0;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/inspection_three/index/part/add.vue